module.exports = __webpack_public_path__ + "assets/dbe3a67141b29f63472d5f0e2618218e.mp4";